var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_vm._v("\n                Bild\n            ")]),_c('v-flex',[_c('register-form')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }